var React = require('react');

function GatsbyMonogram (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#663399;}\n\t.st1{fill:#FFFFFF;}\n"),React.createElement("g",{"id":"monogram","key":1},[React.createElement("circle",{"className":"st0","cx":"14","cy":"14","r":"14","key":0}),React.createElement("g",{"key":1},[React.createElement("path",{"className":"st1","d":"M6.2,21.8C4.1,19.7,3,16.9,3,14.2L13.9,25C11.1,24.9,8.3,23.9,6.2,21.8z","key":0}),React.createElement("path",{"className":"st1","d":"M16.4,24.7L3.3,11.6C4.4,6.7,8.8,3,14,3c3.7,0,6.9,1.8,8.9,4.5l-1.5,1.3C19.7,6.5,17,5,14,5\n\t\t\tc-3.9,0-7.2,2.5-8.5,6L17,22.5c2.9-1,5.1-3.5,5.8-6.5H18v-2h7C25,19.2,21.3,23.6,16.4,24.7z","key":1})])])]);
}

GatsbyMonogram.defaultProps = {"version":"1.1","id":"Ebene_1","x":"0px","y":"0px","viewBox":"0 0 28 28","style":{"enableBackground":"new 0 0 28 28"},"xmlSpace":"preserve"};

module.exports = GatsbyMonogram;

GatsbyMonogram.default = GatsbyMonogram;
